import React from 'react';
import { FacilityAdditionalContactSearchModalTemplate } from 'themes/application/facility/components';
import { observer } from 'mobx-react';
import { FacilityAdditionalContactSearchModalViewStore } from 'application/facility/stores';
import { setCurrentView } from 'core/utils';
@setCurrentView((rootStore, componentProps) => new FacilityAdditionalContactSearchModalViewStore(rootStore, componentProps), 'facilityAdditionalContactSearchModalViewStore')
@observer
class FacilityAdditionalContactSearchModal extends React.Component {
    render() {
        return <FacilityAdditionalContactSearchModalTemplate {...this.props} />
    }
}

export default FacilityAdditionalContactSearchModal;